const firebaseProps= ()=> {
 return  {
        apiKey: "AIzaSyAStqo8q_pWRXHmNn5V5M691_y3-PPAuY4",
        authDomain: "gnp-portalcorporativo-pro.firebaseapp.com",
        databaseURL: "https://gnp-portalcorporativo-pro.firebaseio.com",
        projectId: "gnp-portalcorporativo-pro",
        storageBucket: "gnp-portalcorporativo-pro.appspot.com",
        messagingSenderId: "834427459956"
        }
}


export default firebaseProps;


// WEBPACK FOOTER //
// ./src/properties/firebaseProps.js